import { useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import { blue500, gray300, gray900 } from "../../../uiKit/assets/colors/colors";
import Title from "../../../uiKit/Title/Title";
import AdminsInfo from "../../PersonalSettings/Admins/adminsInfo";
import Members from "../../Members/members";
import OurBalance from "../../OurBalance/ourBalance";
import DraftsWrapper from "../../Drafts/draftsWrapper";
import ActiveCampaigns from "./activeCampaigns";
import CommunityInfo from "./communityInfo";
import CompletedCampaigns from "./completedCampaigns";
import RecentDonationsTableOurBalance from "../../OurBalance/RecentDonations/recentDonationsTable";
import BalanceAccordion from "../../OurBalance/balanceAccordion";

import { setTabType } from "../../../redux/state/communitySlice";
import { getAdmins } from "../../../redux/state/memberSlice";

const CommunityTabs = [
    { id: 0, title: 'Active Campaigns' },
    { id: 1, title: 'Completed Campaigns', onlyForAdmin: true },
    { id: 2, title: 'Recent Donations' },
    { id: 3, title: 'Members', onlyForAdmin: true },
    { id: 4, title: 'Our Balance' },
    { id: 5, title: 'Admins' },
    { id: 6, title: 'Admins Settings', onlyForAdmin: true },
]

const RecentDonations = () => {
    const screenWidth = useSelector(state => state.common.screenWidth, shallowEqual);
    const isMobile = screenWidth < 900
    return isMobile ? <BalanceAccordion includeCampaigns={true} /> : <RecentDonationsTableOurBalance includeCampaigns={true} />
}

const Panels = [
    ActiveCampaigns,
    CompletedCampaigns,
    RecentDonations,
    Members,
    OurBalance,
    AdminsInfo,
    DraftsWrapper,
]

const Community = () => {
    const dispatch = useDispatch();
    const { communityId } = useParams();

    const isAdmin = useSelector(state => state.community.community.role, shallowEqual);
    const tabType = useSelector(state => state.community.tabType, shallowEqual);
    const admins = useSelector(state => state.member.communityAdmins, shallowEqual);

    const Component = Panels[tabType];

    const tabValueHanler = (id) => {
        dispatch(setTabType(id));
    }

    useEffect(() => {
        if (!admins && !!communityId) {
            dispatch(getAdmins(communityId))
        }
    }, [admins, communityId, dispatch])

    return (
        <>
            <CommunityInfo />
            <div className="tabHeader" >
                <div style={{ display: 'flex' }}>
                    {
                        CommunityTabs.filter(y => !y.onlyForAdmin || !!isAdmin)
                            .map(x => <Title
                                key={x.id}
                                text={x.title}
                                onClick={() => tabValueHanler(x.id)}
                                color={tabType === x.id ? blue500 : gray900}
                                style={{
                                    width: 'max-content',
                                    height: '36px',
                                    textAlign: 'center',
                                    padding: '8px 24px',
                                    borderBottom: '2px solid',
                                    borderColor: tabType === x.id ? blue500 : gray300,
                                    cursor: 'pointer',
                                }}
                            />
                            )
                    }
                </div>
            </div>
            <div className="communityDetailsWrapper">
                <Component />
            </div>
        </>
    )
}

export default Community;